export const STAGE_WIDTH = 150;
export const STAGE_RIGHT_PADDING = 150; // Padding to avoid interference with the Collapse button
export const MIN_TOTAL_HEIGHT = 236; // Keep in sync with .workflows-workflowDetailsHeader
export const PADDING_TOP = 42; // Keep in sync with @workflowVisualization-padding-top
export const SCROLLBAR_WIDTH = 8; // Keep in sync with variables.less:@scrollbar-width
export const STAGE_RUN_RADIUS = 6; // Keep in sync with @stageRunVisualization-radius
export const AGGREGATED_STAGE_RUN_RADIUS = 10;
// Keep in sync with left padding of .workflowVisualization-stage-header
export const STAGE_RUN_LEFT_PADDING = 8;
export const STAGE_RUN_RIGHT_PADDING = 60;
